<template>
  <div>
    <popup-hint hint="distilling">
      <template v-slot:breadcrumbs>
        <breadcrumbs home="Distilling">

          <template v-slot:left v-if="incompleteCount">
            <list-notification v-model="showStatus">
              <v-list-item>
                <v-icon>mdi-arrow-right-thin</v-icon>
                {{incompleteCount}} incomplete distillation{{incompleteCount===1?'':'s'}}
                <v-spacer/>
                <v-btn small color="warning" @click="showStatus=false;$nextTick(() => {filters.completeStatus='0';filters.processId=null;filters.from=null;filters.to=null;filters.number=''})">View</v-btn>
              </v-list-item>
            </list-notification>
          </template>

          <template v-slot:right>
            <v-menu offset-y v-if="company.permissions.includes('config.write')" :close-on-content-click="false" nudge-bottom="5" left max-width="500">
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">mdi-tune-variant</v-icon>
              </template>
              <production-distilling-preferences/>
            </v-menu>
          </template>
        </breadcrumbs>
      </template>
      <template v-slot:top>
        You can record all your distillations here.
      </template>
    </popup-hint>

    <v-dialog v-model="showGraph" width="496">
      <component :is="graph" zoomed @close="showGraph=false" :from="graphFrom" :to="graphTo" disableTo/>
    </v-dialog>

    <purtrak-table name="distilling" objectType="distillations" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select show-expand
                   listEndPoint="distillations2" v-model="selected"
                   fields="id,date,number,processId,processName,duration,comments,completed,lot,value,totalOutput,totalLitres"
                   totalFields="totalLAA,totalLitres,totalValue"
                   :totals.sync="totals"
                   :listFilters="listFilters"
                   @dblclick="distillation => $router.push({name:'ProductionDistillingEdit',params:{distillationId:distillation.id}})"
                   :item-class="distillation => (distillation.completed ? '' : 'warning--text')"
                   @itemExpanded="({item, value}) => expandDistillation(item, value)"
                   title="Distilling"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'',filters.completeStatus!=null?(filters.completeStatus=='1'?'Completed':'Incomplete'):'',filters.processId!=null?processName:'']}"
                   download-endpoint="distillationsExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.completeStatus=null;filters.processId=null;filters.from=null;filters.to=null;filters.number=''">
          <v-list-item>
            <filter-search label="Number" v-model="filters.number"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item v-if="preferences.distillIncomplete">
            <v-autocomplete label="Completed" dense outlined :items="[{value:null,text:'All'},{divider:true},{value:'1',text:'Completed'},{value:'0',text:'Incomplete'}]" v-model="filters.completeStatus"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Process" dense outlined :items="processes" item-text="name" item-value="id"  v-model="filters.processId"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.number!=''" close small class="ml-1" @click:close="filters.number=''">#: {{filters.number}}</v-chip>
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.completeStatus!=null" close small class="ml-1" @click:close="filters.completeStatus=null">{{filters.completeStatus=='1'?'Completed':'Incomplete'}}</v-chip>
          <v-chip v-show="filters.processId!=null" close small class="ml-1" @click:close="filters.processId=null">{{processName}}</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <template v-if="!readOnly">
          <v-list-item :to="{name:'ProductionDistillingEditNew'}"><v-list-item-title>Create distillation</v-list-item-title></v-list-item>
          <v-divider/>
        </template>
        <v-list-item :to="{name:'ProductionDistillingProcesses'}"><v-list-item-title>Processes</v-list-item-title></v-list-item>
        <v-menu :nudge-left="220" v-if="!$vuetify.breakpoint.mobile">
          <template v-slot:activator="{on:reports}">
            <v-list-item v-on="reports">
              <v-list-item-title>Reports and graphs</v-list-item-title>
              <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
            </v-list-item>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Distilling',to:{name:'ProductionDistilling'}}]},query:{to:'reports/production/ReportsDistillationActivity'}}">
              <v-list-item-title>Distilling activity</v-list-item-title>
              <v-list-item-action-text>Report</v-list-item-action-text>
            </v-list-item>
            <v-divider/>
            <v-list-item @click="getGraph('DashboardDistillationSummary')">
              <v-list-item-title>Distilling rate</v-list-item-title>
              <v-list-item-action-text>Graph</v-list-item-action-text>
            </v-list-item>
            <v-list-item @click="getGraph('DashboardDistillationHistory')">
              <v-list-item-title>Distilling history</v-list-item-title>
              <v-list-item-action-text>Graph</v-list-item-action-text>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-menu offset-y top>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch commands</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="printDistillationBatch()"><v-list-item-title>Print</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="deleteMultiple=true;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.date="{item,value,printing}">
        {{value | formatDateTime}}
        <div v-if="!item.completed && !printing" class="text-caption"><em>INCOMPLETE</em></div>
      </template>
      <template v-slot:item.processName="{item,printing}">
        {{item.processName}}
        <div v-if="!printing" class="text-caption">{{item.comments}}</div>
      </template>
      <template v-slot:item.duration="{value}">
        {{value | duration}}
      </template>
      <template v-slot:item.value="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.totalOutput="{value}">
        {{value | number(3)}} LAA
      </template>
      <template v-slot:item.totalLitres="{value}">
        {{value | number(3)}}
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'ProductionDistillingEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Distillation operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'ProductionDistillingEdit',params:{distillationId:item.id}}"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item @click="printDistillation(item.id,null,true)"><v-list-item-title>Print</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Distilling',to:{name:'ProductionDistilling'}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:1}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="updateComments(item)"><v-list-item-title>Update comments</v-list-item-title></v-list-item>
              <v-list-item @click="distillation=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete distillation</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:body.append="{headers,printing}" v-if="!$vuetify.breakpoint.mobile">
        <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
          <template v-for="header of headers">
            <td class="text-right" v-if="header.value==='totalOutput'">
              {{totals.totalLAA | number(3)}} LAA
            </td>
            <td class="text-right" v-else-if="header.value==='totalLitres'">
              {{totals.totalLitres | number(3)}}
            </td>
            <td class="text-right" v-else-if="header.value==='value' && values">
              {{totals.totalValue | currency}}
            </td>
            <td v-else-if="!printing || header.print === undefined || header.print"/>
          </template>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length" >
          <v-card class="my-4" :class="expansionPanelClass">
            <v-simple-table dense class="text-caption px-16" :class="expansionPanelClass"  style="width:100%">
              <thead>
                <tr>
                  <th class="py-0" :class="expansionPanelClass" width="30%">Input</th>
                  <th class="py-0" :class="expansionPanelClass" width="30%">Source</th>
                  <th class="py-0" :class="expansionPanelClass" width="10%">Lot</th>
                  <th class="py-0 text-right" :class="expansionPanelClass" width="15%" v-if="values && item.completed">Value</th>
                  <th class="py-0 text-right" :class="expansionPanelClass" width="15%">{{item.completed?'':'Pending '}}Quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(input,index) of item.inputs" :key="index">
                  <td class="text-caption py-0">{{input.typeName}}</td>
                  <td class="text-caption py-0">{{input.vesselName}}</td>
                  <td class="text-caption py-0">
                    <a @click="$router.push({name:'ReportsView',params:{back:[{text:'Distilling',to:{name:'ProductionDistilling'}}]},query:{to:'reports/inventory/ReportsLot',id:input.type==='Item'?input.id:input.vesselId,lot:input.lot,forward:0}})">{{input.lot}}</a>
                  </td>
                  <td class="text-caption py-0 text-right" v-if="values && item.completed">{{input.value | currency}}</td>
                  <td class="text-caption py-0 text-right">{{input.quantity | number(input.precision)}} {{input.units}}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-simple-table dense class="mt-3 text-caption px-16" :class="expansionPanelClass" style="width:100%">
              <thead>
                <tr>
                  <th class="py-0" :class="expansionPanelClass" width="30%">Output</th>
                  <th class="py-0" :class="expansionPanelClass" width="30%">Tank</th>
                  <th class="py-0" :class="expansionPanelClass" width="10%">Lot</th>
                  <th class="py-0 text-right" :class="expansionPanelClass" width="15%" v-if="values && item.completed">Value</th>
                  <th class="py-0 text-right" :class="expansionPanelClass" width="15%">{{item.completed?'':'Pending '}}Quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(output,index) of item.outputs" :key="index">
                  <td class="text-caption py-0">{{output.spiritName}}</td>
                  <td class="text-caption py-0">{{output.tankName}}</td>
                  <td class="text-caption py-0">
                    <a @click="$router.push({name:'ReportsView',params:{back:[{text:'Distilling',to:{name:'ProductionDistilling'}}]},query:{to:'reports/inventory/ReportsLot',id:output.tankId,lot:output.lot,forward:1}})">{{output.lot}}</a>
                  </td>
                  <td class="text-caption py-0 text-right" v-if="values && item.completed">{{output.value | currency}}</td>
                  <td class="text-caption py-0 text-right">
                    {{output.quantity | number(3)}} {{output.nonExcise?'litres':'LAA'}}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </td>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected distillations':'this distillation'" @delete="performDelete(distillation.id)"/>
    <component :is="dialog" v-bind="dialogProperties" @done="dialog = null"/>
  </div>
</template>

<script>
import performDelete from '@/mixins/performDelete'
import googleCharts from '@/mixins/googleCharts'
import productionDistillingPrintDistillation from '@/views/production/distilling/productionDistillingPrintDistillation'
import ProductionDistillingPreferences from '@/views/production/distilling/ProductionDistillingPreferences'
import {format,add} from 'date-fns'

export default {
  name: 'ProductionDistilling',
  mixins: [productionDistillingPrintDistillation,googleCharts,performDelete],
  components: {ProductionDistillingPreferences},
  props: {
    processId: {type:String, required:false, default:null}
  },
  data() {
    return {
      incompleteCount: 0,
      showStatus: false,
      filters: {
        number: '',
        from: null,
        to: null,
        future: '1',
        completeStatus: null,
        processId: this.processId
      },
      preferences: {},
      dateDisplay: '',
      distillation: {},
      totals: {totalValue:0, totalLAA:0, totalLitres:0},
      completeOptions: [{name:'Completed/Incomplete',value:0,divider:true},{name:'Completed only',value:1},{name:'Incomplete only',value:2}],
      processes: [{name:'All processes',id:null},{name:'No process',id:''},{divider:true}],
      showDelete: false,
      deleteMultiple: false,
			dialog: null,
      dialogProperties: {},
      graphFrom: '',
      graphTo: '',
      graph: null,
      showGraph: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'number', visible:true},
                       { value: 'processName', visible:true},
                       { value: 'comments', visible:false},
                       { value: 'duration' ,visible:true},
                       { value: 'totalOutput', visible:false},
                       { value: 'totalLitres', visible:false},
                       { value: 'value', visible:true}],
      headers: [{ text: 'DATE', value: 'date', width:'25%',sortable:true},
                { text: '#', value: 'number', width:'10%',sortable:true},
                { text: 'PROCESS', value: 'processName', width:'30%',sortable:true},
                { text: 'COMMENTS', value: 'comments', width:'30%',sortable:true},
                { text: 'DURATION', value: 'duration', width:'15%',sortable:true, omit:() => !this.preferences.distillDuration},
                { text: 'OUTPUT', value: 'totalOutput', width:'10%',sortable:true,align:'right'},
                { text: 'LITRES', value: 'totalLitres', width:'10%',sortable:true,align:'right', omit:() => !this.trackLitres},
                { text: 'VALUE', value: 'value', width:'10%',sortable:true,align:'right',  omit:() => !this.values}
                ]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    values() {
      return this.company.permissions.includes('values');
    },
    trackLitres() {
      return this.$store.getters.company.settings.trackLitres;
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    processName() {
      return this.processes.find(process => process.id === this.filters.processId)?.name;
    },
    listFilters() {
      const filters = [];
      if (this.filters.number)
        filters.push({field:'number', comparator:'contains', value:this.filters.number});
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.completeStatus == '1' || this.filters.completeStatus == '0')
        filters.push({field:'completed', comparator:'eq', value:this.filters.completeStatus == '1' ? 'true' : 'false'});
      if (this.filters.processId === '')
        filters.push({field:'noProcess', comparator:'eq', value:''});
      else if (this.filters.processId !== null)
        filters.push({field:'processId', comparator:'eq', value:this.filters.processId});
      return filters;
    }
  },
  async created() {
    this.$store.dispatch('checkTasks');
    this.loading = true;
    this.$lazyListLoad(this.processes, 'processes2', 'id,name', 100);
    const results = await this.$apiCall(`query ProductionDistilling {
                                              distillingPreferences {
                                                distillDuration,distillIncomplete
                                              }
                                            }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.distillingPreferences;
    await this.getStatus();
    this.loading = false;
    this.graphTo = format(new Date(), 'yyyy-MM-dd');
    this.graphFrom = format(add(new Date(), {years:-2}), 'yyyy-MM-dd');

    if (!['ProductionDistillingEdit', 'ProductionDistillingEditNew','ProductionDistillingProcessess'].includes(this._previousRoute) &&
        Object.keys(this.$route.query).length === 0 &&
        this.incompleteCount && !localStorage.getItem('hideNotification')) {
      this.$nextTick(() => this.showStatus = true);
      setTimeout(() => this.showStatus = false, 10_000);  // Close in 10 seconds
    }
  },
  methods: {
    async getStatus() {
      const results = await this.$apiCall(`query ProductionDistilling {
                                             distillationsIncomplete
                                          }`);
      if (!results.error)
        this.incompleteCount = results.data.distillationsIncomplete;
    },
    async getGraph(name) {
      await this.loadGoogleCharts();
      this.graph = () => import(`@/views/dashboard/${name}`);
      this.showGraph = true;
    },
    async expandDistillation(item, value) {
      if (value && !item.inputs) {
        this.loading = true;
        const results = await this.$apiCall(`query ProductionDistilling($id:ID!) {
                                                  distillation(id:$id) {
                                                    inputs{type,typeName,vesselId,id,vesselName,lot,quantity,value,units,precision},
                                                    outputs{spiritName,tankName,tankId,lot,quantity,value,nonExcise,litres}
                                                  }
                                                }`,
                                            {id:item.id});
        this.$set(item, 'inputs', results.data.distillation.inputs);
        this.$set(item, 'outputs', results.data.distillation.outputs);
        this.loading = false;
      }
    },
    updateComments(distillation) {
      this.dialogProperties = {item:distillation, operation:'blendUpdateComments'};
      this.dialog = () => import(`@/views/production/ProductionUpdateComments`);
    },
    async printDistillationBatch() {
      const lines = [];
      let n = this.selected.length;
      for (const distillation of this.selected) {
        lines.push(... await this.printDistillation(distillation.id, null, false));
        if (--n)
          lines.push(`<div class="page-break"/>`);
      }
      this.printHtml('Distillation',lines.join(''));
    }
  }
}
</script>